import React, { FC, memo } from "react";
import styles from "./ToastMessage.module.scss";
import { Portal } from "react-portal";
import { useTypedSelector } from "../../cores/useTypedSelector";
import ToastMessageItem from "./ToastMessageItem/ToastMessageItem";

interface Props {}

const ToastMessage: FC<Props> = memo(() => {
  const toasts = useTypedSelector(state => state.toast.toasts);

  return (
    <Portal>
      <div className={styles.toastMessage}>
        {toasts.map((toast, key) => (
          <ToastMessageItem
            key={toast.id}
            y={toasts.length - key - 1}
            {...toast}
          />
        ))}
      </div>
    </Portal>
  );
});

export default ToastMessage;
